<template>
  <div class="chatgpt-container h-full w-full overflow-hidden bg-white">
    <div id="chatgpt-iframe-wrapper" class="h-full w-full">
      <div class="relative z-0 flex h-full w-full overflow-hidden">
        <!-- Sidebar -->
        <div class="flex-shrink-0 overflow-x-hidden bg-token-sidebar-surface-primary" style="width: 260px;">
          <div class="h-full w-[260px]">
            <div class="flex h-full min-h-0 flex-col">
              <div class="flex h-full min-h-0 flex-col">
                <div class="scrollbar-trigger relative h-full w-full flex-1 items-start border-white/20">
                  <nav class="flex h-full w-full flex-col px-3 pb-3.5" aria-label="Chat history">
                    <div class="flex-col flex-1 transition-opacity duration-500 -mr-2 pr-2 overflow-y-auto">
                      <div class="sticky left-0 right-0 top-0 z-20 bg-token-sidebar-surface-primary pt-3.5">
                        <div class="pb-0.5 last:pb-0" tabindex="0">
                          <a 
                            class="group flex h-10 items-center gap-2 rounded-lg bg-token-sidebar-surface-primary px-2 font-medium hover:bg-token-sidebar-surface-secondary cursor-pointer" 
                            @click="startNewChat"
                          >
                            <div class="h-7 w-7 flex-shrink-0">
                              <div class="gizmo-shadow-stroke relative flex h-full items-center justify-center rounded-full bg-token-main-surface-primary text-token-text-primary">
                                <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-2/3 w-2/3" role="img">
                                  <text x="-9999" y="-9999">ChatGPT</text>
                                  <path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="currentColor"></path>
                                </svg>
                              </div>
                            </div>
                            <div class="grow overflow-hidden text-ellipsis whitespace-nowrap text-sm text-token-text-primary">New chat</div>
                          </a>
                        </div>
                      </div>
                      
                      <!-- Divider Line -->
                      <div class="border-t border-token-border-medium my-2 mx-2"></div>
                      
                      <!-- Chat History List -->
                      <div class="flex flex-col gap-1">
                        <div 
                          v-for="chat in chatHistory" 
                          :key="chat.id"
                          class="group relative flex items-center gap-2 rounded-lg px-2 py-2 text-sm hover:bg-token-sidebar-surface-secondary cursor-pointer"
                          :class="{ 'bg-token-sidebar-surface-secondary': currentChatId === chat.id }"
                          @click="loadChat(chat.id)"
                        >
                          <div class="flex-1 overflow-hidden min-w-0">
                            <div class="text-token-text-primary truncate">{{ chat.title || 'New Chat' }}</div>
                            <div class="text-token-text-tertiary text-xs truncate">{{ formatDate(chat.updatedAt) }}</div>
                          </div>
                          <button 
                            @click.stop="deleteChat(chat.id)"
                            class="opacity-0 group-hover:opacity-100 transition-opacity text-token-text-tertiary hover:text-token-text-primary p-1 flex-shrink-0"
                            title="Delete chat"
                          >
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M6 6V12M10 6V12M2 4H14M12 4V13.3333C12 14 11.3333 14.6667 10.6667 14.6667H5.33333C4.66667 14.6667 4 14 4 13.3333V4M5.33333 4V2.66667C5.33333 2 5.66667 1.33333 6.33333 1.33333H9.66667C10.3333 1.33333 10.6667 2 10.6667 2.66667V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Vertical Divider between Sidebar and Main Content -->
        <div class="w-px h-full bg-token-border-medium flex-shrink-0"></div>

        <!-- Main Content Area -->
        <div class="relative flex h-full max-w-full flex-1 flex-col overflow-hidden">
          <main class="relative h-full w-full flex-1 overflow-auto transition-width">
            <div role="presentation" class="flex h-full flex-col">
              <div class="flex-1 overflow-hidden">
                <div class="h-full overflow-y-auto">
                  <div style="padding: 0px;">
                    <div class="flex flex-col text-sm pb-9">
                      <div class="sticky top-0 mb-1.5 flex items-center justify-between z-10 h-14 p-2 font-semibold bg-token-main-surface-primary">
                        <div class="flex items-center gap-2">
                          <div class="group flex cursor-pointer items-center gap-1 rounded-xl py-2 px-3 text-lg font-medium hover:bg-token-main-surface-secondary">
                            <div>ChatGPT <span class="text-token-text-secondary">3.5</span></div>
                          </div>
                        </div>
                      </div>
                      
                      <!-- Messages Container -->
                      <div class="w-full text-token-text-primary max-w-full overflow-x-hidden" dir="auto">
                        <div class="px-4 py-2 justify-center text-base md:gap-6 m-auto max-w-full">
                          <!-- Initial Welcome Message -->
                          <div v-if="messages.length === 0" class="flex flex-1 text-base mx-auto gap-3 md:gap-6 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] max-w-full px-4">
                            <div class="flex-shrink-0 flex flex-col relative items-end">
                              <div class="pt-0.5">
                                <div class="gizmo-bot-avatar flex h-6 w-6 items-center justify-center overflow-hidden rounded-full">
                                  <div class="relative p-1 rounded-sm flex items-center justify-center bg-token-main-surface-primary text-token-text-primary h-6 w-6">
                                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-sm" role="img">
                                      <text x="-9999" y="-9999">ChatGPT</text>
                                      <path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="currentColor"></path>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="relative flex w-full min-w-0 flex-col agent-turn">
                              <div class="font-semibold select-none">ChatGPT</div>
                              <div class="flex-col gap-1 md:gap-3">
                                <div class="flex flex-grow flex-col max-w-full">
                                  <div class="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words">
                                    <div class="markdown prose w-full break-words dark:prose-invert light">
                                      <p>Hello! I'm ChatGPT. How can I help you?</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Conversation Messages -->
                          <div 
                            v-for="(msg, index) in messages" 
                            :key="index"
                            class="flex flex-1 text-base mx-auto gap-3 md:gap-6 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] mb-4 max-w-full px-4"
                          >
                            <!-- User Message -->
                            <div v-if="msg.role === 'user'" class="relative flex w-full min-w-0 flex-col">
                              <div class="font-semibold select-none">You</div>
                              <div class="flex-col gap-1 md:gap-3">
                                <div class="flex flex-grow flex-col max-w-full">
                                  <div class="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words">
                                    <div class="markdown prose w-full break-words">
                                      <p>{{ msg.content }}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- Assistant Message -->
                            <div v-else class="w-full">
                              <div class="flex flex-1 text-base mx-auto gap-3 md:gap-6 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem]">
                                <div class="flex-shrink-0 flex flex-col relative items-end">
                                  <div class="pt-0.5">
                                    <div class="gizmo-bot-avatar flex h-6 w-6 items-center justify-center overflow-hidden rounded-full">
                                      <div class="relative p-1 rounded-sm flex items-center justify-center bg-token-main-surface-primary text-token-text-primary h-6 w-6">
                                        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-sm" role="img">
                                          <path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="currentColor"></path>
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="relative flex w-full min-w-0 flex-col agent-turn">
                                  <div class="font-semibold select-none">ChatGPT</div>
                                  <div class="flex-col gap-1 md:gap-3">
                                    <div class="flex flex-grow flex-col max-w-full">
                                      <div class="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words">
                                        <div class="markdown prose w-full break-words dark:prose-invert light">
                                          <p v-if="msg.isLoading">Thinking...</p>
                                          <p v-else-if="msg.error" class="text-red-400">{{ msg.error }}</p>
                                          <p v-else>{{ msg.content }}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Loading indicator -->
                          <div v-if="isLoading" class="flex flex-1 text-base mx-auto gap-3 md:gap-6 md:px-5 lg:px-1 xl:px-5 md:max-w-3xl lg:max-w-[40rem] xl:max-w-[48rem] mb-4 max-w-full px-4">
                            <div class="flex-shrink-0 flex flex-col relative items-end">
                              <div class="pt-0.5">
                                <div class="gizmo-bot-avatar flex h-6 w-6 items-center justify-center overflow-hidden rounded-full">
                                  <div class="relative p-1 rounded-sm flex items-center justify-center bg-token-main-surface-primary text-token-text-primary h-6 w-6">
                                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-sm" role="img">
                                      <path d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z" fill="currentColor"></path>
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="relative flex w-full min-w-0 flex-col agent-turn">
                              <div class="font-semibold select-none">ChatGPT</div>
                              <div class="flex-col gap-1 md:gap-3">
                                <div class="flex flex-grow flex-col max-w-full">
                                  <div class="min-h-[20px] text-message flex flex-col items-start gap-3 whitespace-pre-wrap break-words">
                                    <div class="markdown prose w-full break-words dark:prose-invert light">
                                      <p>Thinking...</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Input Area -->
              <div style="padding-left: 0px; padding-right: 0px;" class="w-full pt-2 md:pt-0 dark:border-white/20 md:border-transparent md:dark:border-transparent md:w-[calc(100%-.5rem)]">
                <form class="stretch mx-2 flex flex-row gap-3 last:mb-2 md:mx-4 md:last:mb-6 lg:mx-auto lg:max-w-2xl xl:max-w-3xl max-w-full" @submit.prevent="sendMessage">
                  <div class="relative flex h-full max-w-full flex-1 flex-col">
                    <div class="flex w-full items-center">
                      <div class="overflow-hidden flex flex-col w-full flex-grow relative border dark:text-white rounded-2xl bg-token-main-surface-primary border-token-border-medium">
                        <textarea 
                          id="prompt-textarea" 
                          tabindex="0" 
                          dir="auto" 
                          rows="1" 
                          placeholder="Message ChatGPT…" 
                          class="m-0 w-full resize-none border-0 bg-transparent focus:ring-0 focus-visible:ring-0 dark:bg-transparent py-[10px] pr-10 md:py-3.5 md:pr-12 max-h-[25dvh] max-h-52 placeholder-black/50 dark:placeholder-white/50 pl-4 md:pl-6"
                          v-model="message"
                          @keydown.enter.exact.prevent="sendMessage"
                          @keydown.shift.enter.exact.prevent="message += '\n'"
                          :disabled="isLoading"
                          style="height: 52px; overflow-y: hidden;"
                        ></textarea>
                        <button 
                          type="submit"
                          class="absolute bottom-1.5 right-2 rounded-lg border border-black bg-black p-0.5 text-white transition-colors enabled:bg-black disabled:text-gray-400 disabled:opacity-10 dark:border-white dark:bg-white dark:hover:bg-white md:bottom-3 md:right-3"
                          :disabled="!message.trim() || isLoading"
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" class="text-white dark:text-black">
                            <path d="M7 11L12 6L17 11M12 18V7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div class="relative px-2 py-2 text-center text-xs text-token-text-secondary md:px-[60px]">
                  <span>ChatGPT can make mistakes. Consider checking important information.</span>
                  <span v-if="errorMessage" class="block text-red-400 mt-1">{{ errorMessage }}</span>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, onMounted, watch } from 'vue'
import axios from 'axios'
import './ChatGPT.styles.css'

const message = ref('')
const messages = ref([])
const isLoading = ref(false)
const errorMessage = ref('')
const currentChatId = ref(null)
const chatHistory = ref([])

// API endpoint - defaults to localhost:3001, can be configured via env
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001'

// Load chat history from localStorage
const loadChatHistory = () => {
  try {
    const saved = localStorage.getItem('chatgpt-history')
    if (saved) {
      chatHistory.value = JSON.parse(saved)
      // Sort by updatedAt (newest first)
      chatHistory.value.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    }
  } catch (error) {
    console.error('Error loading chat history:', error)
    chatHistory.value = []
  }
}

// Save chat history to localStorage
const saveChatHistory = () => {
  try {
    localStorage.setItem('chatgpt-history', JSON.stringify(chatHistory.value))
  } catch (error) {
    console.error('Error saving chat history:', error)
  }
}

// Save current chat
const saveCurrentChat = () => {
  if (!currentChatId.value || messages.value.length === 0) return
  
  const chatIndex = chatHistory.value.findIndex(c => c.id === currentChatId.value)
  const firstUserMessage = messages.value.find(m => m.role === 'user')
  const title = firstUserMessage?.content?.substring(0, 50) || 'New Chat'
  
  const chatData = {
    id: currentChatId.value,
    title: title,
    messages: messages.value,
    updatedAt: new Date().toISOString()
  }
  
  if (chatIndex >= 0) {
    chatHistory.value[chatIndex] = chatData
  } else {
    chatHistory.value.unshift(chatData)
  }
  
  // Keep only last 50 chats
  if (chatHistory.value.length > 50) {
    chatHistory.value = chatHistory.value.slice(0, 50)
  }
  
  // Sort by updatedAt
  chatHistory.value.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
  
  saveChatHistory()
}

// Format date for display
const formatDate = (dateString) => {
  if (!dateString) return ''
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)
  
  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m ago`
  if (diffHours < 24) return `${diffHours}h ago`
  if (diffDays < 7) return `${diffDays}d ago`
  
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

// Load a specific chat
const loadChat = (chatId) => {
  const chat = chatHistory.value.find(c => c.id === chatId)
  if (chat) {
    // Save current chat before switching
    if (currentChatId.value) {
      saveCurrentChat()
    }
    
    currentChatId.value = chatId
    messages.value = JSON.parse(JSON.stringify(chat.messages || []))
    errorMessage.value = ''
    
    // Update chat's updatedAt
    chat.updatedAt = new Date().toISOString()
    saveChatHistory()
    
    // Scroll to bottom
    nextTick(() => {
      scrollToBottom()
    })
  }
}

// Delete a chat
const deleteChat = (chatId) => {
  if (confirm('Are you sure you want to delete this chat?')) {
    chatHistory.value = chatHistory.value.filter(c => c.id !== chatId)
    saveChatHistory()
    
    if (currentChatId.value === chatId) {
      currentChatId.value = null
      messages.value = []
    }
  }
}

const sendMessage = async () => {
  if (!message.value.trim() || isLoading.value) return
  
  const userMessage = message.value.trim()
  const currentMessage = userMessage
  
  // Create new chat if we don't have one
  if (!currentChatId.value) {
    currentChatId.value = 'chat-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
  }
  
  // Clear input immediately
  message.value = ''
  errorMessage.value = ''
  
  // Add user message to conversation
  messages.value.push({
    role: 'user',
    content: currentMessage
  })
  
  // Scroll to bottom
  await nextTick()
  scrollToBottom()
  
  // Add loading placeholder for assistant
  const assistantMessageIndex = messages.value.length
  messages.value.push({
    role: 'assistant',
    content: '',
    isLoading: true
  })
  
  isLoading.value = true
  
  try {
    // Build conversation history for context
    const conversationHistory = messages.value
      .filter(msg => !msg.isLoading && !msg.error)
      .slice(0, -1) // Exclude the loading placeholder
      .map(msg => ({
        role: msg.role,
        content: msg.content
      }))
    
    // Make API call to backend
    const response = await axios.post(`${API_BASE_URL}/api/chat`, {
      input: currentMessage,
      messages: conversationHistory,
      model: 'gemini-2.0-flash'
    })
    
    // Update assistant message with response
    messages.value[assistantMessageIndex] = {
      role: 'assistant',
      content: response.data.content || 'No response received',
      isLoading: false
    }
    
    // Save chat after receiving response
    saveCurrentChat()
    
    // Scroll to bottom after response
    await nextTick()
    scrollToBottom()
    
  } catch (error) {
    console.error('Error sending message:', error)
    
    // Update assistant message with error
    messages.value[assistantMessageIndex] = {
      role: 'assistant',
      content: '',
      error: error.response?.data?.error || error.message || 'Failed to get response. Please check if the backend server is running.',
      isLoading: false
    }
    
    errorMessage.value = error.response?.data?.error || 'Failed to connect to server. Make sure the backend is running on port 3001.'
    
    await nextTick()
    scrollToBottom()
  } finally {
    isLoading.value = false
  }
}

const startNewChat = () => {
  // Save current chat before starting new one
  if (currentChatId.value && messages.value.length > 0) {
    saveCurrentChat()
  }
  
  currentChatId.value = null
  messages.value = []
  errorMessage.value = ''
  message.value = ''
}

const scrollToBottom = () => {
  const container = document.querySelector('.h-full.overflow-y-auto')
  if (container) {
    container.scrollTop = container.scrollHeight
  }
}

onMounted(() => {
  // Load chat history
  loadChatHistory()
  
  // Check if backend is running
  axios.get(`${API_BASE_URL}/api/health`)
    .then(() => {
      console.log('✅ Backend server is connected')
    })
    .catch(() => {
      console.warn('⚠️ Backend server not found. Make sure to run: npm run server')
      errorMessage.value = 'Backend server not running. Please start it with: npm run server'
    })
})

// Watch for messages changes to auto-save
watch(() => messages.value.length, () => {
  if (messages.value.length > 0 && currentChatId.value) {
    // Debounce saves
    clearTimeout(window.chatSaveTimeout)
    window.chatSaveTimeout = setTimeout(() => {
      saveCurrentChat()
    }, 2000)
  }
})
</script>

<style scoped>
/* Container-specific overrides */
.chatgpt-container {
  font-family: Söhne, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, Helvetica Neue, Arial, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}

/* Ensure ChatGPT styles are applied within container */
.chatgpt-container * {
  font-family: inherit;
}

/* Responsive fixes - prevent content from overflowing */
.chatgpt-container .max-w-full {
  max-width: 100% !important;
}

.chatgpt-container .overflow-x-hidden {
  overflow-x: hidden !important;
}

/* Ensure messages wrap properly */
.chatgpt-container .text-message {
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
}

.chatgpt-container .prose {
  max-width: 100% !important;
  overflow-wrap: break-word;
  word-wrap: break-word;
}

/* Sidebar chat history styling */
.chatgpt-container .text-token-text-tertiary {
  color: #8e8ea0;
}
</style>
